import { mapState } from 'vuex'

export default {
  static() {
    return {
      /**
       * для esc логики. Если карта открыта, должна закрываться только карта
       * Для того чтобы не зависеть от порядка навешивания обработчиков на
       * событие keydown, то воспользуемся этим флагом, устанавлвается он в 
       * watch editedRouteTask.length и используется в обработчике onEscPress
       */
       isOpenMapFlag: false
    }
  },
  computed: {
    ...mapState({
      editedRouteTask: state => state.routeTasks.editedRouteTask
    })
  },
  mounted() {
    window.addEventListener('keydown', this.onEscPress)
  },
  beforeDestroy() {
    window.removeEventListener('keydown', this.onEscPress)
  },
  methods: {
    onEscPress(e) {
      if (e.key === 'Escape') {
        if (this.isOpenMapFlag) {
          this.isOpenMapFlag = false
          return
        }
        this.$router.go(-1)
      }
    }
  },
  watch: {
    /**
     * 
     * editedRouteTask.length может устанавливаться синхронно
     * или асинхронно. Чтобы не зависеть от этого, воспользуемся
     * флагом isOpenMapFlag
     */
    'editedRouteTask.length'(data) {
      if (data) {
        this.isOpenMapFlag = true
      }
    }
  }
}